module.exports = __webpack_public_path__ + "img/home.bfc09eff.svg";